import { rcsOptInRenderSchema } from "@redotech/redo-marketing-common/carrier-registration/rcs-opt-in-signup-form";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { startRcsRegistration } from "./start-rcs-registration";

const StartedOrBlocked = z.object({
  status: z.enum(["started", "blocked"]),
  /** Poll `getRcsRegistrationAsset` with this. */
  workflowId: z.string().optional(),
  reason: z.string().optional(),
  detail: z.string().optional(),
  missingFields: z.array(z.string()).optional(),
});

/** Captures the storefront's live signup popup at its phone step. */
export const generateRcsOptInScreenshot = {
  name: "generateRcsOptInScreenshot" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: StartedOrBlocked,
};

/** The live signup popup, for the client to draw at its phone step. */
export const getRcsOptInRender = {
  name: "getRcsOptInRender" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: rcsOptInRenderSchema,
};

/** Renders the preview video from the form as it would be submitted. */
export const generateRcsPreviewVideo = {
  name: "generateRcsPreviewVideo" as const,
  input: startRcsRegistration.input,
  output: StartedOrBlocked,
};

export const getRcsRegistrationAsset = {
  name: "getRcsRegistrationAsset" as const,
  input: z.object({ teamId: zExt.objectId(), workflowId: z.string() }),
  output: z.object({
    status: z.enum(["running", "completed", "failed"]),
    detail: z.string().optional(),
    screenshotUrl: z.string().optional(),
    /** The consent text read off the captured form. */
    disclosure: z.string().optional(),
    testUrl: z.string().optional(),
  }),
};
